import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';

const pb23CarouselGroups = {
    init: function () {
        console.log("pb23-carousel--groups: INIT");
        // Toggle Submenus 
        $('.jsCarouselGroup').each(function()
        {
            var jsCarContent = new Splide(this, {
                arrows: true,
                pagination: false,
                autoplay: false,
                drag: 'free',
                autoWidth: true
            }).mount();
        })
        
    }
}

window.loadedComponents.push({ component: 'pb23-carousel--groups', init: pb23CarouselGroups.init});

export default() => {
    pb23CarouselGroups.init();
}